// src/components/manager-v2/ManagerOrgView.js
import React, { useState } from 'react';
import Organization from '../admin/onboarding/Organization';
import FunctionalStructure from '../admin/onboarding/FunctionalStructure';

const ManagerOrgView = () => {
    const [activeTab, setActiveTab] = useState('organization');

    return (
        <div className="space-y-6">
            {/* Header */}
            <div>
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                    Organization View
                </h1>
                <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                    View organization and functional structure
                </p>
            </div>

            {/* Tabs */}
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
                <div className="border-b border-gray-200 dark:border-gray-700">
                    <div className="flex space-x-8 px-6">
                        <button
                            onClick={() => setActiveTab('organization')}
                            className={`py-4 px-2 border-b-2 font-medium text-sm transition-colors ${
                                activeTab === 'organization'
                                    ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
                            }`}
                        >
                            ORGANIZATION STRUCTURE
                        </button>
                        <button
                            onClick={() => setActiveTab('functional')}
                            className={`py-4 px-2 border-b-2 font-medium text-sm transition-colors ${
                                activeTab === 'functional'
                                    ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                                    : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
                            }`}
                        >
                            FUNCTIONAL STRUCTURE
                        </button>
                    </div>
                </div>

                {/* Tab Content */}
                <div className="p-6">
                    {activeTab === 'organization' && <Organization readOnly={true} />}
                    {activeTab === 'functional' && <FunctionalStructure readOnly={true} />}
                </div>
            </div>
        </div>
    );
};

export default ManagerOrgView;
